"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ByteLengthStrategy = exports.Transform = exports.Readable = void 0;
let Readable;
let Transform;
let ByteLengthStrategy;
if (typeof window !== 'undefined') {
    exports.Readable = Readable = ReadableStream;
    exports.Transform = Transform = TransformStream;
    exports.ByteLengthStrategy = ByteLengthStrategy = ByteLengthQueuingStrategy;
}
else {
    const webstream = require('stream/web');
    exports.Readable = Readable = webstream.ReadableStream;
    exports.Transform = Transform = webstream.TransformStream;
    exports.ByteLengthStrategy = ByteLengthStrategy = webstream.ByteLengthQueuingStrategy;
}
